/* eslint-disable
    @trello/enforce-file-ownership,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const Auth = require('app/scripts/db/auth');
const SimpleTest = require('app/common/lib/experiments/simple-test').default;
const { memberId } = require('@trello/session-cookie');
const getAudienceDefinitions = require('app/common/lib/experiments/audience-definitions')
  .default;

const testCache = {};
const getMember = function () {
  let me;
  if ((me = Auth.me())) {
    return me.toJSON();
  } else {
    return null;
  }
};
const audienceDefinitions = getAudienceDefinitions(getMember);
const simpleTest = new SimpleTest(audienceDefinitions);

module.exports = function (testName, identifier) {
  identifier = identifier || memberId || 'notLoggedIn';
  const key = [testName, identifier].filter((a) => a).join(':');
  return testCache[key] != null
    ? testCache[key]
    : (testCache[key] = simpleTest.getParams(testName, identifier));
};
